<template>
  <b-modal
    size="md"
    hide-footer
    v-model="show"
    :title="`Edição da Configuração`"
    @hidden="cancelar"
  >
    <b-card>
      <b-row>
        <b-col cols="12">
          <div><span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}</div>
        </b-col>
      </b-row>
    </b-card>
    <b-form @submit.prevent="salvar">
      <b-form-group>
        <LgFinderPageUnidadeAdministrativa
          id="finderUnidadeAdministrativaModalPainelDeConfiguracao"
          v-model="form.unidadeAdministrativa"
          :podeApagarDepartamento="false"
          label="Unidade Administrativa:"
          @onselect="handleSelectUnidadeAdministrativa"
        />
      </b-form-group>

      <b-form-group>
        <LgFinderPageLocalArmazenamento
          :podeApagar="false"
          id="finderLocalArmazenamentoModalPainelDeConfiguracao"
          v-model="form.localizacaoFisica"
          label="Localização Física:"
          @close="handleSelectLocalArmazenamento"
          :departamento="form.unidadeAdministrativa"
        />
      </b-form-group>

      <b-form-row class="d-flex justify-content-center">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue";
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";

export default {
  components: {
    LgFinderPageUnidadeAdministrativa,
    LgFinderPageLocalArmazenamento,
  },
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        unidadeAdministrativa: null,
        localizacaoFisica: null,
      },
    };
  },
  methods: {
    handleSelectUnidadeAdministrativa(unidade) {
      this.form.unidadeAdministrativa = unidade;
      this.form.localizacaoFisica = null;
    },
    handleSelectLocalArmazenamento(localizacao) {
      this.form.localizacaoFisica = localizacao;
    },
    async salvar() {
      if (!this.form.unidadeAdministrativa || !this.form.localizacaoFisica) {
        this.$bvToast.toast("Selecione a Unidade Administrativa e a Localização Física", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      const valorPropriedade = [
        this.form.unidadeAdministrativa.id,
        this.form.localizacaoFisica.id,
      ].join(";");

      const payload = {
        id: this.configuracao.id,
        valorPropriedade,
      };

      try {
        await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
        this.$emit("salvo");
        await Swal.fire({
          title: "Sucesso",
          text: "Configuração salva com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar configuração", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },
    cancelar() {
      this.$emit("close");
    },
    async carregarDadosIniciais() {
      if (this.configuracao.valorPropriedade) {
        const valores = this.configuracao.valorPropriedade.split(";");
        this.form.unidadeAdministrativa = {
          id: parseInt(valores[0], 10),
          descricao: this.configuracao.unidadeAdministrativaLabel,
        }
        this.form.localizacaoFisica = {
          id: parseInt(valores[1], 10),
          descricao: this.configuracao.localArmazenamentoLabel,
        }
      }
    },
  },
  mounted() {
    this.carregarDadosIniciais();
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
</style>
